import React from "react";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import TextField from "@mui/material/TextField";

import AssetItemImage from "../../../components/capture/aseet-list/AssetItemImage";

const styles = {
  row: {
    moved: {
      backgroundColor: "#f0f8ff",
    },
    moving: {
      position: "relative",
      overflow: "hidden",
      backgroundColor: "#fafafa",
      "@keyframes shimmer": {
        "0%": { transform: "translateX(-100%)" },
        "100%": { transform: "translateX(100%)" },
      },
      "&::after": {
        content: '""',
        position: "absolute",
        top: 0,
        left: 0,
        width: "50%",
        height: "100%",
        background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.6), transparent)",
        animation: "shimmer 1.5s ease-in-out infinite",
      },
    },
  },
};

export default function BulkAddToCartTable({
  assets,
  statusMap,
  quantityOverrides = {},
  onQuantityChange,
  processing = false,
}) {
  if (!assets || assets.length === 0) return null;

  const getEffectiveQty = asset =>
    quantityOverrides[asset.id] !== undefined
      ? quantityOverrides[asset.id]
      : asset.availableQuantity;

  const handleQtyChange = (asset, rawValue) => {
    if (rawValue === "") {
      onQuantityChange(asset.id, "");
      return;
    }
    const parsed = parseInt(rawValue, 10);
    if (isNaN(parsed)) return;
    const clamped = Math.min(Math.max(1, parsed), asset.availableQuantity);
    onQuantityChange(asset.id, clamped);
  };

  const handleQtyBlur = (asset, rawValue) => {
    if (rawValue === "" || isNaN(parseInt(rawValue, 10))) {
      onQuantityChange(asset.id, asset.availableQuantity);
    }
  };

  return (
    <Box my={2} display="flex" flexDirection="column" alignItems="center" width="100%">
      <Box mt={2} width="100%" maxHeight={300} sx={{ overflow: "auto" }}>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell align="center">Image</TableCell>
              <TableCell align="center">Item ID</TableCell>
              <TableCell align="center">Description</TableCell>
              <TableCell align="center">Quantity</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {assets.map(asset => (
              <TableRow key={asset.id} sx={styles.row[statusMap?.[asset.id]] || {}}>
                <TableCell align="center">
                  <AssetItemImage images={asset.images} />
                </TableCell>
                <TableCell align="center">{asset.itemId || asset.assetId}</TableCell>
                <TableCell align="center">{asset.description || "-"}</TableCell>
                <TableCell align="center">
                  {onQuantityChange ? (
                    <TextField
                      type="number"
                      size="small"
                      value={getEffectiveQty(asset)}
                      onChange={e => handleQtyChange(asset, e.target.value)}
                      onBlur={e => handleQtyBlur(asset, e.target.value)}
                      disabled={processing || !!statusMap?.[asset.id]}
                      inputProps={{
                        min: 1,
                        max: asset.availableQuantity,
                        style: { textAlign: "center" },
                      }}
                      sx={{
                        width: 80,
                        "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                          WebkitAppearance: "none",
                          margin: 0,
                        },
                        "& input[type=number]": {
                          MozAppearance: "textfield",
                        },
                      }}
                    />
                  ) : (
                    asset.availableQuantity
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
    </Box>
  );
}
